var _a, _b;
import { EmptyIcon } from "../../adapters/presenters/action-interfaces/Reports/HoldingReport";
export var enterMail = "Please Enter email.";
export var validMail = "Please Enter valid email address.";
export var ReportsEnum;
(function (ReportsEnum) {
    ReportsEnum["HOLDINGS"] = "holdings";
    ReportsEnum["POSITIONS"] = "positions";
    ReportsEnum["PNL"] = "Profit and Loss";
    ReportsEnum["TXN"] = "transactions";
    ReportsEnum["TAX"] = "tax";
    ReportsEnum["DP"] = "dp transactions";
    ReportsEnum["SUBSCRIPTION"] = "Subscription";
    ReportsEnum["ACCOUNTOVERVIEW"] = "AccountOverview";
    ReportsEnum["LEDGER"] = "ledger";
    ReportsEnum["DPC"] = "Delayed Payment Interest";
    ReportsEnum["DPBILL"] = "DPBILL";
    ReportsEnum["CONTRACTNOTES"] = "Contract notes";
    ReportsEnum["HOLDING_REVAMP"] = "holding_revamp";
    ReportsEnum["POSITION_REVAMP"] = "position_revamp";
})(ReportsEnum || (ReportsEnum = {}));
export var EmptyValidation = (_a = {},
    _a[EmptyIcon.EMPTY] = (_b = {},
        _b[ReportsEnum.HOLDINGS] = {
            icon: "edel-icon-emtpy_icon",
            message: "You don't have any ".concat(ReportsEnum.HOLDINGS, "."),
        },
        _b[ReportsEnum.DP] = {
            icon: "edel-icon-reports-note",
            message: "You don't have any ".concat(ReportsEnum.DP, "."),
        },
        _b[ReportsEnum.DPBILL] = {
            icon: "edel-icon-reports-note",
            message: "No results found! ",
        },
        _b[ReportsEnum.DPC] = {
            icon: "edel-icon-reports-note",
            message: "No results found! ",
        },
        _b[ReportsEnum.POSITIONS] = {
            icon: "edel-icon-emtpy_icon",
            message: "You don't have any ".concat(ReportsEnum.POSITIONS, "."),
        },
        _b[ReportsEnum.PNL] = {
            icon: "edel-icon-emtpy_icon",
            message: "No records are available for the <br/> entered period, try a new period.",
        },
        _b[ReportsEnum.TAX] = {
            icon: "edel-icon-emtpy_icon",
            message: "No records are available for the <br/> entered period, try a new period.",
        },
        _b[ReportsEnum.TXN] = {
            icon: "edel-icon-emtpy_icon",
            message: "No records are available for the <br/> entered period, try a new period.",
        },
        _b[ReportsEnum.SUBSCRIPTION] = {
            icon: "edel-icon-reports-note",
            message: "No results found! ",
        },
        _b[ReportsEnum.CONTRACTNOTES] = {
            icon: "edel-icon-reports-note",
            message: "No results found! ",
        },
        _b[ReportsEnum.ACCOUNTOVERVIEW] = {
            icon: "edel-icon-emtpy_icon",
            message: "No records are available for the <br/> entered period, try a new period.",
        },
        _b[ReportsEnum.LEDGER] = {
            icon: "edel-icon-reports-note path1",
            message: "No results found! <br/>\n      Try searching for something else",
        },
        _b[ReportsEnum.HOLDING_REVAMP] = {
            icon: "edel-icon-no-holdings",
            message: "You don\u2019t have any holdings<br/> Try searching for something else",
        },
        _b[ReportsEnum.POSITION_REVAMP] = {
            icon: "edel-icon-reports-note",
            message: "No results found! <br/>\n      Try searching for something else",
        },
        _b),
    _a[EmptyIcon.SEARCH] = {
        icon: "edel-icon-wentwrong-search",
        message: "There are no entries matching your search criteria.",
    },
    _a[EmptyIcon.SEARCH_NEW] = {
        icon: "edel-icon-wentwrong-search",
        message: "Couldn’t find anything! <br/> Try searching for something else",
    },
    _a[EmptyIcon.FILTER] = {
        icon: EmptyIcon.FILTER,
        message: "There are no entries matching your filter criteria.",
    },
    _a.default = "No Data available",
    _a.noOpenOrder = "Seems like there are no open orders in your order book.",
    _a.noClosedOrder = "Seems like there are no closed orders in your order book.",
    _a.noNcdOrder = "Seems like there are no NCD IPO orders in your order book.",
    _a.noIpoOrder = "Seems like there are no IPO orders in your order book.",
    _a.noOfsOrder = "Seems like there are no OFS orders in your order book.",
    _a.noSipOrder = "Seems like there are no ESIP orders in your order book.",
    _a.noResultsFound = "No results found",
    _a[EmptyIcon.ERROR] = {
        icon: "edel-icon-emtpy_icon",
        message: "Something went wrong! Please try after sometime.",
    },
    _a[EmptyIcon.ERROR_EXCLA] = {
        icon: "edel-icon-report-excla",
        message: "No results found! <br/>\n      Try searching for something else",
    },
    _a);
export var aifDesclaimer = "Face Value is considered in Price for AIF.";
export var pnlTablemessage = "Quantity in PnL report is post doing adjustment of corporate action on Ex Date. Actual impact in Demat Holding might take longer time. Hence, there might be difference in quantity as per Pnl and Holding Report.";
